import React, { useLayoutEffect } from 'react';
import { useAsyncValue, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

// Components
import WorkEquipmentForm from '../../../../../components/forms/ActionForms/WorkEquipmentForm';

// Types
import { WorkEquipmentFormValues } from '../../../../../components/forms/ActionForms/WorkEquipmentForm/types';
import { OrderActionReferences } from '../types';
import { Role } from '../../../../../types/auth';

// Constants
import { formActionValidationNaming } from '../../../../../components/forms/ActionForms/constants';

// Redux
import { roidOTSelected } from '../../../../../state/actions/ui/roidOTSelectedGeneralView';

// Hooks
import { useAuth } from '../../../../../hooks/useAuth';

export default function WorkEquipmentValidationFormPage(): JSX.Element {
  const { t } = useTranslation('validation');
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const loaderData = useAsyncValue() as WorkEquipmentFormValues &
    OrderActionReferences & {
      parentExpeditionOrderStatus?: string;
      state?: string;
    };

  // Get current user role - RoomTeam can only view, not edit
  const { user } = useAuth();
  const isReadOnly = user?.user?.rolActive === Role.RoomTeam;

  const onFormSubmit = () => {
    if (isReadOnly) return; // RoomTeam cannot submit
    navigate('../animals');
  };

  useLayoutEffect(() => {
    dispatch(
      roidOTSelected('actions-validation', loaderData.roid!, loaderData.orderId)
    );
  }, []);

  return (
    <WorkEquipmentForm
      onFormSubmit={isReadOnly ? () => {} : onFormSubmit}
      initialData={loaderData}
      sessionStorageKey={
        formActionValidationNaming.NEW_VALIDATION_WORK_EQUIPMENT_FORM
      }
      updateKey={formActionValidationNaming.DATA_CHANGES}
      textButton={isReadOnly ? t('viewOnly') : user?.user?.rolActive === Role.Tablet ? t('buttons:continue') : t('validate')}
    />
  );
}
